import { Box, Stack } from '@rhg/libs/material';

const styleContainer = {
    mb: 3,
};

const stylePrimaryIconContainer = {
    borderRadius: '100%',
    display: 'inline-flex',
    padding: 2,
    backgroundColor: 'background.paper',
    color: 'primary.main',
};

interface IconWithWhiteCircleProps {
    children: React.ReactNode;
}

export default function IconWithWhiteCircle({
    children,
}: IconWithWhiteCircleProps) {
    return (
        <Stack sx={styleContainer} alignItems="center">
            <Box sx={stylePrimaryIconContainer}>{children}</Box>
        </Stack>
    );
}
